export default __webpack_public_path__ + "static/fb2-9fe1e2c93b4be7aa6091bb6f099362c4.png";